<script>
export default {
  filters: {
    comma(n) {
      const number = parseFloat(n, 10);
      if (number) {
        return number.toLocaleString();
      }
      return "0";
    },
    // 日付をフォーマット
    dateFormat(date) {
      const weekName = ["日", "月", "火", "水", "木", "金", "土"];
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();

      let str = y + "年" + m + "月" + d + "日 ";
      return str + weekName[date.getDay()] + "曜日";
    },
    dateFormatShort(date) {
      if (!date) {
        return "";
      }
      const weekName = ["日", "月", "火", "水", "木", "金", "土"];
      const m = date.getMonth() + 1;
      const d = date.getDate();

      let str = m + "月" + d + "日 (";
      return str + weekName[date.getDay()] + ")";
    },
    dateFormatYmdJp(date) {
      if (!date) {
        return "";
      }
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();

      let str = y + "年" + m + "月" + d + "日";
      return str;
    },
    // 日付をフォーマット
    dateFormatYM(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;

      let str = y + "年" + m + "月";
      return str;
    },
    // 商品1行に対する合計金額を計算
    total(data) {
      let price = parseInt(data.total_tax_price, 10);
      price += parseInt(data.send_price, 10);
      price -= parseInt(data.service_price, 10);
      return price;
    },
    changeDateObject(str) {
      return new Date(str);
    }
  },
  methods: {
    ymd(date) {
      const y = date.getFullYear();
      const m = ("0" + (date.getMonth() + 1)).slice(-2);
      const d = ("0" + date.getDate()).slice(-2);

      return y + m + d;
    },
    ymdJp(date) {
      const weekName = ["日", "月", "火", "水", "木", "金", "土"];
      const y = date.getFullYear();
      const m = ("0" + (date.getMonth() + 1)).slice(-2);
      const d = ("0" + date.getDate()).slice(-2);

      let str = y + "年" + m + "月" + d + "日";
      return str + "（" + weekName[date.getDay()] + "）";
    },
    ymdFormat(date) {
      const y = date.getFullYear();
      const m = ("0" + (date.getMonth() + 1)).slice(-2);
      const d = ("0" + date.getDate()).slice(-2);

      return y + "/" + m + "/" + d;
    },
    mdFormat(date) {
      const m = date.getMonth() + 1;
      const d = date.getDate();

      return m + "/" + d;
    },
    calcableDate(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();

      const day = new Date(y, m - 1, d);
      return day;
    },
    // 日付を YYYYMMDD の整数に変換（税率の期間判定用。TZ差で境界日がズレないようローカル年月日で比較する）
    taxYmd(date) {
      // "YYYY年M月D日" 形式（請求書の表示日付など new Date で解釈できないもの）にも対応する
      if (typeof date === "string") {
        const jp = date.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
        if (jp) {
          return Number(jp[1]) * 10000 + Number(jp[2]) * 100 + Number(jp[3]);
        }
      }
      let d = date ? new Date(date) : new Date();
      if (isNaN(d.getTime())) {
        d = new Date();
      }
      return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    },
    // 消費税率（％）を返す。バックエンド BaseAction::tax() と同じ定義。
    //   taxClass は「税率区分の識別子」（値そのものは率ではない）:
    //     8  ... 軽減税率の区分（〜2027/3 は 8%、2027/4 以降は 1%）
    //     10 ... 標準税率の区分（送料・真空代もこの区分。常に 10%）
    //   実際の率は対象日で決まる。今後また率が変わる場合は rateTables の先頭に追加する。
    tax(date, taxClass) {
      const rateTables = [
        // 2027-04-01 以降: 軽減税率を 8% → 1% に改定
        { from: 20270401, rates: { 8: 1, 10: 10 } },
        // 従来（〜2027/3）
        { from: 0, rates: { 8: 8, 10: 10 } }
      ];
      const ymd = this.taxYmd(date);
      for (const table of rateTables) {
        if (ymd >= table.from) {
          const rate = table.rates[taxClass];
          return rate === undefined ? 0 : rate;
        }
      }
      return 0;
    },
    // 税抜金額 → 税込金額（四捨五入）
    taxIncluded(excluded, date, taxClass) {
      return Math.round(excluded * (1 + this.tax(date, taxClass) / 100));
    },
    // 税込金額 → 税抜金額（端数処理は呼び出し側に委ねる）
    taxExcluded(included, date, taxClass) {
      return included / (1 + this.tax(date, taxClass) / 100);
    },
    // 税抜金額に対する消費税額
    taxAmount(excluded, date, taxClass) {
      return this.taxIncluded(excluded, date, taxClass) - excluded;
    },
    // 税区分の表示名。tax_class は率ではなく区分の識別子なので、率(%)ではなく区分名を表示する。
    //   8 ... 軽減税率 / 10 ... 標準税率
    //   short=true は一覧など狭い列向けの短縮形（軽減 / 標準）。
    taxClassLabel(taxClass, short = false) {
      const labels = short
        ? { 8: "軽減", 10: "標準" }
        : { 8: "軽減税率", 10: "標準税率" };
      return labels[taxClass] === undefined ? "" : labels[taxClass];
    }
  }
};
</script>
